<main class="loyale-auth-page loyale-auth-page--centered">
  <div class="auth-brand"><img src="../../../assets/logo.svg" alt="Loyale"></div>
  <section class="auth-card" aria-label="Signing out">
    <div class="auth-card__content auth-status">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="44"></mat-progress-spinner>
      <span>Signing you out…</span>
    </div>
  </section>
</main>
